/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { titleAndAdvisoryJSX } from '../../../../helpers/commonJSX'

export const statsJSX = (
  reviewerProfile,
  width
) => {

  // console.log('reviewerProfile ->', reviewerProfile)

  // Stats JSX
  const statsJSX = () => {

    const getAverageStarRating = () => {
      if (
        // 'profileReviews' in reviewerProfile 
        // && reviewerProfile.profileReviews !== null 
        // && reviewerProfile.profileReviews.length > 0
        // && 
        'reviewerReviews' in reviewerProfile
        && reviewerProfile.reviewerReviews !== null 
        && reviewerProfile.reviewerReviews.length > 0
      ) {

        let totalStars = 0
        for (let i = 0; i < reviewerProfile.reviewerReviews.length; i++) {
          totalStars = totalStars + reviewerProfile.reviewerReviews[i].starRating
        }

        const averageStars = parseFloat((totalStars / reviewerProfile.reviewerReviews.length).toFixed(1))

        return `${averageStars} / 5.0`

      } else {
        return 'NA'
      }
    }

    return (
      <Box
        sx={{
          mt: 1,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {/* Profiles Reviewed */}
        <Box
          sx={{
            // backgroundColor: 'yellow',
            mt: 0,
            mb: 0.5,
            width: '100%', maxWidth: '200px',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            // flexWrap: 'wrap',
          }}
        >
          <Typography
            sx={{
              mr: 3,
              fontWeight: 'bold',
            }}
          >
            {/* {'profileReviews' in reviewerProfile && reviewerProfile.profileReviews !== null && reviewerProfile.profileReviews.length > 0 ? `Profiles Reviewed:` : `Reviews:`} */}
            {`Reviews:`}
            {/* {console.log('reviewerProfile ->', reviewerProfile)} */}
          </Typography>

          <Typography
            sx={{
              fontWeight: 'bold',
              color: 'blue',
            }}
          >
            {/* {'profileReviews' in reviewerProfile && reviewerProfile.profileReviews !== null && reviewerProfile.profileReviews.length > 0 ? reviewerProfile.profileReviews.length : 'reviewerReviews' in reviewerProfile && reviewerProfile.reviewerReviews !== null && reviewerProfile.reviewerReviews.length > 0 ? reviewerProfile.reviewerReviews.length : 0 } */}
            {'reviewerReviews' in reviewerProfile && reviewerProfile.reviewerReviews !== null && reviewerProfile.reviewerReviews.length > 0 ? reviewerProfile.reviewerReviews.length : 0 }
          </Typography>
        </Box>

        {/* Star Rating */}
        <Box
          sx={{
            // backgroundColor: 'yellow',
            mt: 0,
            width: '100%', maxWidth: '200px',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            // flexWrap: 'wrap',
          }}
        >
          <Typography
            sx={{
              mr: 3,
              fontWeight: 'bold',
            }}
          >
            Star Rating:
          </Typography>

          <Typography
            sx={{
              fontWeight: 'bold',
              color: 'blue',
            }}
          >
            {getAverageStarRating()}
          </Typography>
        </Box>
      </Box>
    )
  }

  const reviewsJSX = () => {

    return (
      <Box
        sx={{
          mt: 1,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {reviewerProfile.reviewerReviews.map((review, reviewIndex) => (
          <Box
            key={reviewIndex}
            sx={{
              my: 2, px: 2, py: 2,
              width: '100%',
              backgroundColor: 'white',
              borderRadius: 3, boxShadow: 3,
              border: 2, borderColor: 'black',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            {/* Review Text */}
            <Box
              sx={{
                width: '100%',
                fontStyle: 'italic',
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {'reviewText' in review && review.reviewText.length > 0 ? `"${review.reviewText}" — ${review.profileReviewedFirstName}, ${review.starRating} stars` : `(No written review) — ${review.profileReviewedFirstName}, ${review.starRating} stars` }
            </Box>

          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      {/* Stats Section */}
      {/* Title and Advisory JSX */}
      {titleAndAdvisoryJSX(
        'Stats', 
        'Reviewer Feedback',
        0
      )}

      {/* Stats JSX */}
      {statsJSX()}

      {/* Reviews */}
      {/* {console.log('reviewerProfile.reviewerReviews ->', reviewerProfile.reviewerReviews)} */}
      {'reviewerReviews' in reviewerProfile
      && reviewerProfile.reviewerReviews !== null 
      && reviewerProfile.reviewerReviews.length > 0
      &&
        reviewsJSX()
      }

    </Box>
  )
}